var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFinalCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53,
    height: 52,
    viewBox: "0 0 53 52",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1782 38.6667C21.4235 39.9846 23.8641 40.6436 26.5 40.6436C29.1359 40.6436 31.5765 39.9846 33.8218 38.6667C36.0672 37.3487 37.8489 35.5671 39.1668 33.3217C40.4847 31.0764 41.1437 28.6357 41.1437 25.9999C41.1437 23.364 40.4847 20.9234 39.1668 18.678C37.8489 16.4327 36.0672 14.651 33.8218 13.3331C31.5765 12.0152 29.1359 11.3562 26.5 11.3562C23.8641 11.3562 21.4235 12.0152 19.1782 13.3331C16.9328 14.651 15.1511 16.4327 13.8332 18.678C12.5153 20.9234 11.8563 23.364 11.8563 25.9999C11.8563 28.6357 12.5153 31.0764 13.8332 33.3217C15.1511 35.5671 16.9328 37.3487 19.1782 38.6667ZM17.3477 26.2928L18.6412 24.926C18.8365 24.7308 19.0561 24.6331 19.3246 24.6331C19.5931 24.6331 19.8127 24.7308 20.008 24.926L24.1326 29.0506L32.992 20.1912C33.1873 19.996 33.4069 19.8983 33.6754 19.8983C33.9439 19.8983 34.1635 19.996 34.3588 20.1912L35.6523 21.558C35.8475 21.7044 35.9452 21.9241 35.9452 22.2169C35.9452 22.5098 35.8475 22.7051 35.6523 22.8759L24.7916 33.7366C24.6451 33.9319 24.4255 34.0295 24.1326 34.0295C23.8397 34.0295 23.6445 33.9319 23.4736 33.7366L17.3233 27.5863C17.128 27.4398 17.0304 27.2202 17.0304 26.9273C17.0304 26.6344 17.128 26.4392 17.3233 26.2683L17.3477 26.2928Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 46.4713C15.2093 46.4713 6.02874 37.2908 6.02874 26.0001C6.02874 14.7094 15.2093 5.52881 26.5 5.52881C37.7907 5.52881 46.9713 14.7094 46.9713 26.0001C46.9713 37.2908 37.7907 46.4713 26.5 46.4713ZM26.5 8.67823C16.9415 8.67823 9.17816 16.4416 9.17816 26.0001C9.17816 35.5586 16.9415 43.3219 26.5 43.3219C36.0585 43.3219 43.8218 35.5586 43.8218 26.0001C43.8218 16.4416 36.0585 8.67823 26.5 8.67823Z",
    fill: "url(#paint0_linear_1696_15018)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 51.4023C12.5005 51.4023 1.0977 39.9994 1.0977 26C1.0977 12.0005 12.5005 0.597656 26.5 0.597656C40.4995 0.597656 51.9023 12.0005 51.9023 26C51.9023 39.9994 40.4995 51.4023 26.5 51.4023ZM26.5 3.42013C14.0529 3.42013 3.92018 13.5528 3.92018 26C3.92018 38.4471 14.0529 48.5798 26.5 48.5798C38.9471 48.5798 49.0798 38.4471 49.0798 26C49.0798 13.5528 38.9471 3.42013 26.5 3.42013Z",
    fill: "url(#paint1_linear_1696_15018)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1696_15018",
    x1: 40.4992,
    y1: 12.0009,
    x2: 15.1778,
    y2: 37.3223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "white",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "white",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "white",
    stopOpacity: 0.21
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "white",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1696_15018",
    x1: 8.54904,
    y1: 43.9509,
    x2: 42.6728,
    y2: 9.82716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "white",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "white",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "white",
    stopOpacity: 0.21
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "white",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinalCheck);
export default __webpack_public_path__ + "static/media/final-check.18485f0476bf3302f047a3bfbfb883cb.svg";
export { ForwardRef as ReactComponent };